import { render, staticRenderFns } from "./chequesDeposits.vue?vue&type=template&id=22cf0981&scoped=true&"
import script from "./chequesDeposits.vue?vue&type=script&lang=js&"
export * from "./chequesDeposits.vue?vue&type=script&lang=js&"
import style0 from "./chequesDeposits.vue?vue&type=style&index=0&id=22cf0981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf0981",
  null
  
)

export default component.exports